import { render, staticRenderFns } from "./ProgramTemplateTable.vue?vue&type=template&id=025b159e&scoped=true&"
import script from "./ProgramTemplateTable.vue?vue&type=script&lang=js&"
export * from "./ProgramTemplateTable.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTemplateTable.vue?vue&type=style&index=0&id=025b159e&scoped=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025b159e",
  null
  
)

export default component.exports